/**
 * Per-turn repo edit context keyed by assistant message id (V5 validation).
 */

export interface RepoEditTurnContext {
  fullFilePaths: string[];
  repoTreePaths: string[];
  allowRepoEdit: boolean;
}

const byAssistantId = new Map<string, RepoEditTurnContext>();

export function setRepoEditTurnContext(assistantId: string, ctx: RepoEditTurnContext): void {
  byAssistantId.set(assistantId, ctx);
  if (byAssistantId.size > 50) {
    const first = byAssistantId.keys().next().value;
    if (first) byAssistantId.delete(first);
  }
}

export function getRepoEditTurnContext(assistantId: string): RepoEditTurnContext | undefined {
  return byAssistantId.get(assistantId);
}
